var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CodeMirror',{ref:"editor",staticClass:"code-editor",attrs:{"value":_vm.code,"options":_vm.cmOptions},on:{"update":_vm.update,"cursorActivity":_vm.cursor}})
}
var staticRenderFns = []

export { render, staticRenderFns }